import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import CityPage from "@/pages/CityPage";
import ServicePage from "@/pages/ServicePage";
import { cityPages } from "@/seo/cityPages";
import { servicePages } from "@/seo/servicePages";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPage />} />
            {cityPages.map((p) => (
              <Route key={p.slug} path={`/${p.slug}`} element={<CityPage page={p} />} />
            ))}
            {servicePages.map((p) => (
              <Route key={p.slug} path={`/${p.slug}`} element={<ServicePage page={p} />} />
            ))}
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;